import { render, staticRenderFns } from "./purchaseAndSaleSecendDetail.vue?vue&type=template&id=0984abdc&scoped=true"
import script from "./purchaseAndSaleSecendDetail.vue?vue&type=script&lang=js"
export * from "./purchaseAndSaleSecendDetail.vue?vue&type=script&lang=js"
import style0 from "./purchaseAndSaleSecendDetail.vue?vue&type=style&index=0&id=0984abdc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0984abdc",
  null
  
)

export default component.exports